export default __webpack_public_path__ + "static/media/logo.4811ba3d.png";